export const QUIZ_QUESTIONS_RU = [
  {
    id: "q1_gpu_count",
    title: "Сколько GPU в вашей инфраструктуре?",
    options: [
      { label: "До 32", score: 2 },
      { label: "32–128", score: 5 },
      { label: "128–512", score: 8 },
      { label: "512+", score: 10 },
    ],
  },
  {
    id: "q2_utilization",
    title: "Какова средняя утилизация GPU?",
    options: [
      { label: "До 25%", score: 10 },
      { label: "25–45%", score: 8 },
      { label: "45–65%", score: 5 },
      { label: "65%+", score: 2 },
    ],
  },
  {
    id: "q3_workload",
    title: "Преобладающий тип нагрузки",
    options: [
      { label: "Обучение крупных моделей", score: 8 },
      { label: "Инференс в проде", score: 8 },
      { label: "Смешанная (training + inference)", score: 10 },
      { label: "R&D / эксперименты", score: 5 },
    ],
  },
  {
    id: "q4_scheduler",
    title: "Что используется как планировщик?",
    options: [
      { label: "Стандартный K8s scheduler", score: 10 },
      { label: "Kueue / Volcano", score: 6 },
      { label: "SLURM / собственное решение", score: 7 },
      { label: "Не уверен(а)", score: 5 },
    ],
  },
  {
    id: "q5_pain",
    title: "Главная боль инфраструктуры",
    options: [
      { label: "Простой GPU и высокий TCO", score: 10 },
      { label: "Фрагментация ресурсов", score: 9 },
      { label: "Очереди задач и SLA", score: 8 },
      { label: "Отсутствие FinOps-контроля", score: 7 },
    ],
  },
];

export const QUIZ_QUESTIONS_EN = [
  {
    id: "q1_gpu_count",
    title: "How many GPUs are in your infrastructure fleet?",
    options: [
      { label: "Up to 32", score: 2 },
      { label: "32–128", score: 5 },
      { label: "128–512", score: 8 },
      { label: "512+ GPUs", score: 10 },
    ],
  },
  {
    id: "q2_utilization",
    title: "What is your average cluster GPU utilization?",
    options: [
      { label: "Under 25%", score: 10 },
      { label: "25–45%", score: 8 },
      { label: "45–65%", score: 5 },
      { label: "65%+", score: 2 },
    ],
  },
  {
    id: "q3_workload",
    title: "Primary workload profile",
    options: [
      { label: "Large Foundation Model Training", score: 8 },
      { label: "High-Throughput Production Inference", score: 8 },
      { label: "Mixed Workloads (Training + Inference)", score: 10 },
      { label: "R&D Experiments & Notebooks", score: 5 },
    ],
  },
  {
    id: "q4_scheduler",
    title: "Current workload scheduling platform",
    options: [
      { label: "Default Kubernetes Scheduler", score: 10 },
      { label: "Kueue / Volcano", score: 6 },
      { label: "SLURM / Proprietary In-House Scheduler", score: 7 },
      { label: "Not sure / Hybrid", score: 5 },
    ],
  },
  {
    id: "q5_pain",
    title: "Primary infrastructure challenge",
    options: [
      { label: "Idle GPU silicon & runaway TCO", score: 10 },
      { label: "HBM memory fragmentation & cold GPUs", score: 9 },
      { label: "Queue latency & violated customer SLAs", score: 8 },
      { label: "Lack of granular FinOps governance", score: 7 },
    ],
  },
];

export const QUIZ_QUESTIONS = QUIZ_QUESTIONS_RU;

export const getQuizQuestions = (lang = "ru") =>
  lang === "en" ? QUIZ_QUESTIONS_EN : QUIZ_QUESTIONS_RU;
